import { createIcon } from '../CreateIcon';

export const IconLogRules = createIcon({
  viewBox: '0 0 24 24',
  paths: (
    <>
      <path
        d="M21.2859 7.90815H15.385L20.6913 1.20368C20.8011 1.06172 20.702 0.855469 20.5225 0.855469H10.2502C10.1752 0.855469 10.1029 0.895647 10.0654 0.962612L3.12523 12.9492C3.04219 13.0912 3.14398 13.2706 3.31005 13.2706H7.98148L5.58683 22.8492C5.53594 23.0581 5.78773 23.2055 5.94308 23.0555L21.4333 8.27511C21.5725 8.14386 21.4788 7.90815 21.2859 7.90815ZM8.70201 17.9046L10.3172 11.4492H6.10112L11.1797 2.67958H17.1958L11.6163 9.73225H17.2681L8.70201 17.9046Z"
        fill="black"
        fillOpacity="0.45"
      />
    </>
  ),
});
